 document.addEventListener('DOMContentLoaded', function() {
    const drawerCountSpan = document.querySelector('.ctm-cart-items-count [data-cart-count]');
    const drawerLabelSpan = document.querySelector('.ctm-cart-item-label');
    const headerCartIcon = document.querySelector('.header__cart__status[data-cart-count]');

    function updateDrawerDisplay(count) {
      // GUARD: Only update if count is a valid number/string and NOT "undefined"
      if (count !== null && count !== undefined && count !== 'undefined' && count !== '') {
        drawerCountSpan.textContent = count;
        if (drawerLabelSpan) {
          drawerLabelSpan.textContent = parseInt(count) === 1 ? 'item' : 'items';
        }
      }
    }

    // 1. WATCHER: Only triggers when the header actually changes 
    // (This skips the initial 'undefined' state on product pages)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'data-cart-count') {
          const newCount = mutation.target.getAttribute('data-cart-count');
          updateDrawerDisplay(newCount);
        }
      });
    });

    if (headerCartIcon) {
      observer.observe(headerCartIcon, { attributes: true });
      
      // 2. SELF-CORRECTION: If the header is currently broken (undefined), 
      // we fix the header using the Liquid value we know is right.
      const currentHeaderVal = headerCartIcon.getAttribute('data-cart-count');
      if (currentHeaderVal === 'undefined' || currentHeaderVal === null) {
         // Get the correct number from our Liquid-rendered span
         const correctInitialValue = drawerCountSpan.getAttribute('data-cart-count');
         headerCartIcon.setAttribute('data-cart-count', correctInitialValue);
      }
    }
  });
